import React from 'react'
import { Form as AntFormV3 } from 'antd'
import { FormItemProps } from 'antd/lib/form'
import { omit } from 'lodash'
import { defaultProps } from '@config/antd.config'

export type TExtendFormItem = FormItemProps & {
  children: React.ReactNode
}

const Item = (props: TExtendFormItem) => {
  return (
    <AntFormV3.Item
      {...omit(defaultProps.formItem, 'children')}
      {...{ style: { ...defaultProps.formItem?.style, ...props.style }, ...omit(props, 'children') }}
    >
      {props.children}
    </AntFormV3.Item >
  )
}

export default Item
